import {
  IErrorMonitor,
  MonitoringLevel,
  MonitoringUser,
} from "../../domain/monitoring/IErrorMonitor";

export class NoopMonitor implements IErrorMonitor {
  captureException(_error: unknown, _context?: Record<string, unknown>): void {}
  captureMessage(_message: string, _level?: MonitoringLevel, _extra?: Record<string, unknown>): void {}
  setUser(_user: MonitoringUser): void {}
  clearUser(): void {}
}
